<template>
    <div></div>
</template>

<style lang="scss">
    #toast-container {
        margin-top: 10px !important;
    }

    #toast-container > .toast {
        border-radius: 0 !important;
    }

    #toast-container > .toast-error {
        background-color: $danger-high !important;
    }

    #toast-container > .toast-warning {
        background-color: $danger-medium !important;
    }

    #toast-container > .toast-success {
        background-color: $base-color !important;
    }
</style>
